import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';
import { Dialog } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import SampleVehicleModelAvailabilityWriteDTO
    from '../../../../../../types/sample-vehicle-model/SampleVehicleModelAvailabilityWriteDTO';
import Sample from '../../../../../../types/sample/Sample';
import VehicleModel from '../../../../../../types/vehicle-model/VehicleModel';
import { UtilsService } from '../../../../services/utils.service';
import { VehicleModelService } from '../../../../services/vehicle-model.service';

@Component({
    selector: 'app-change-sample-vehicle-model-availability-dialog',
    imports: [
        Button,
        Dialog,
        FormsModule,
        IftaLabelModule,
        DatePicker
    ],
    templateUrl: './change-sample-vehicle-model-availability-dialog.component.html',
    styleUrl: './change-sample-vehicle-model-availability-dialog.component.scss'
})
export class ChangeSampleVehicleModelAvailabilityDialogComponent implements OnChanges {

    @Input() public visible: boolean = false;
    @Input() public sample: Sample | null = null;
    @Input() public vehicleModel: VehicleModel | null = null;

    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public availabilityChange: EventEmitter<void> = new EventEmitter<void>();

    // Dates
    public availabilityDate: Date | undefined;
    public expirationDate: Date | undefined

    public loading: boolean = false;

    constructor(private vehicleModelService: VehicleModelService,
                private utilsService: UtilsService,
                private messageService: MessageService) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue === true) {
            this.retrieveDates();
        }
    }

    public retrieveDates(): void {
        this.availabilityDate = this.vehicleModel?.sampleAvailabilityDate ?
            this.utilsService.convertDateStringToDate(this.vehicleModel?.sampleAvailabilityDate) : undefined;
        this.expirationDate = this.vehicleModel?.sampleExpirationDate ?
            this.utilsService.convertDateStringToDate(this.vehicleModel?.sampleExpirationDate) : undefined;
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public save() {
        this.loading = true;
        let availabilityDTO: SampleVehicleModelAvailabilityWriteDTO = new SampleVehicleModelAvailabilityWriteDTO({
            availabilityDate: this.utilsService.convertDateToDateString(this.availabilityDate),
            expirationDate: this.utilsService.convertDateToDateString(this.expirationDate),
        });

        this.vehicleModelService.changeSampleAvailability(this.vehicleModel!.id!, this.sample!.id!, availabilityDTO)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Availability has been updated.',
                    life: 3000
                });
                this.availabilityChange.emit();
                this.close();
            })
            .catch((error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000
                });
            }).finally(() => {
            this.loading = false;
        });
    }

    public clearAvailabilityDate() {
        this.availabilityDate = undefined;
    }

    public clearExpirationDate() {
        this.expirationDate = undefined;
    }
}
